const FormSelect = ({ label = "", name = "", list = [], float = false, value="", onChange, readOnly = false }) => {
    const floatClass = float ? "form-floating" : "form-group";

    return (
        <div className={floatClass}>
            {float ? (
                <>
                    <select className="form-select" id={name} name={name} value={value} onChange={onChange} disabled={readOnly}>
                        {list.map((item) => (
                            <option key={item.value} value={item.value}>
                                {item.label}
                            </option>
                        ))}
                    </select>
                    {label && (<label htmlFor={name}>{label}</label>)}
                </>
            ) : (
                <>
                    {label && (<label htmlFor={name}>{label}</label>)}
                    <select className="form-select" id={name} name={name} value={value} onChange={onChange} disabled={readOnly}>
                        {list.map((item) => (
                            <option key={item.value} value={item.value}>
                                {item.label}
                            </option>
                        ))}
                    </select>
                </>
            )}
        </div>
    );
};

export default FormSelect;
